<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <canvas-navigation-tabs :selectedTab.sync="selectedTabNavegationTabs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <canvas-data-table
          ref="canvasDataTable"
          :titulo="tituloTabela"
          :items="items"
          :loading="loading"
          @rechargeTable="chargeTableDecision(tipoListaCanvas)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CanvasService from '@/services/CanvasService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      CanvasNavigationTabs: () => import('@/components/canvas/CanvasNavigationTabs'),
      CanvasDataTable: () => import('@/components/canvas/CanvasDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      tituloTabela: 'Mapas Personalizados',
      selectedTabNavegationTabs: 0,
      loading: false
    }),

    computed: {
      tipoListaCanvas() {
        return this.$store.getters.getTipoListaCanvas;
      }
    },

    created() {
      this.chargeTableDecision(this.tipoListaCanvas);
    },

    methods: {
      getCanvas() {
        this.items = [];
        this.loading = true;
        CanvasService.getCanvas()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      getCanvasFavoritados() {
        this.items = [];
        this.loading = true;
        CanvasService.getCanvasFavoritados()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      chargeTableDecision(newDecisionInfo) {
        if (this.$refs.canvasDataTable) {
          this.$refs.canvasDataTable.page = 1;
        }

        this.tituloTabela = newDecisionInfo.titulo;

        switch (newDecisionInfo.tipo) {
          case 'favoritos':
            this.selectedTabNavegationTabs = 1;
            this.cancelRefreshData();
            this.refreshData(this.getCanvasFavoritados);
            break;
          case 'historico':
          default:
            this.selectedTabNavegationTabs = 0;
            this.cancelRefreshData();
            this.refreshData(this.getCanvas);
            break;
        }
      }
    },

    watch: {
      tipoListaCanvas(newValue) {
        this.chargeTableDecision(newValue);
      }
    }
  };
</script>
